import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { Users } from 'components/icons'

type Props = IconProps

const Group: FC<Props> = (props) => {
  return <Users {...props} />
}

const GroupExports = {
  Group,
}

export default GroupExports
